var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('portal',{attrs:{"order":_vm.order,"to":"page-title-actions"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }